export default __webpack_public_path__ + "static/media/_DSC7470.e9702af6.jpg";